import React from 'react'
import { Box, Input2FA } from '@node-space/ui-components'

type TwoFactorProps = {
  error?: string
  isLoading?: boolean
  onChange: (value: string) => void
}

const TwoFaField = ({ error, isLoading, onChange }: TwoFactorProps) => {
  return (
    <Box className="mt-6">
      <Input2FA testId="otc-2FA-input" loading={isLoading} error={error} onChange={onChange} />
    </Box>
  )
}

export const TWO_FA_REQUIRED_LENGTH = 6

export default React.memo(TwoFaField)
